
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div *ngIf="(calendarRepository.daysInWeek != 3 && isMobileScreen) || (!isMobileScreen)" [ngClass]="{'hidden-view': calendarRepository.daysInWeek == 3 && isMobileScreen}">
<!-- // new day view custom start -->
<div class="cal-week-view cal-view-one-day-view" [ngClass]="{'hidden-view': calendarRepository.daysInWeek != 1}">
   <div *ngIf="newApptOnedayViewFramePositionTop" class="cal-event cal-mobile-event-new custom-oneday-frame"
        [style.top.px]="newApptOnedayViewFramePositionTop">
        <span class="cal-mobile-event-start-dot"></span>
        <span class="cal-mobile-event-end-dot"></span>
      </div>

  <div class="cal-week-view-header" (swipeleft)="onViewSwipe($event)" (swiperight)="onViewSwipe($event)">
    <vp-calendar-week-view-header [days]="days" [locale]="locale" [customTemplate]="headerTemplate"
      (dayHeaderClicked)="dayHeaderClicked.emit($event)"
      (eventDropped)="eventDropped({ dropData: $event }, $event.newStart, true)"
      [class.hide-header]="calendarRepository.daysInWeek  === 1">
    </vp-calendar-week-view-header>
    <div class="cal-all-day-events" #allDayEventsContainer
      *ngIf="view.allDayEventRows.length > 0 && calendarRepository.daysInWeek  !== 1" mwlDroppable
      (dragEnter)="eventDragEnter = eventDragEnter + 1" (dragLeave)="eventDragEnter = eventDragEnter - 1">
      <div class="cal-day-columns">
        <div class="cal-time-label-column">
          <span class="all-day-title">{{ 'CALENDARS.ALL_DAY_LBL' | translate }}</span>
        </div>
        <div class="cal-day-column" [class.cal-weekend]="day.isWeekend"
          *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate" mwlDroppable dragOverClass="cal-drag-over"
          (drop)="eventDropped($event, day.date, true)"
          (contextmenu)="hourSegmentContextMenuClicked.emit({ $event: $event, segment: day.date, allDay: true })"></div>
      </div>
      <div class="week-scroll-all-day for-one-day-view">
        <div *ngFor="let eventRow of view.allDayEventRows; trackBy: trackById" #eventRowContainer
          class="cal-events-row">
          <div *ngFor="
            let allDayEvent of eventRow.row;
            trackBy: trackByDayOrWeekEvent
          " #event class="cal-event-container" [class.cal-draggable]="
            allDayEvent.event.draggable && allDayEventResizes.size === 0
          " [class.cal-starts-within-week]="!allDayEvent.startsBeforeWeek"
            [class.cal-ends-within-week]="!allDayEvent.endsAfterWeek" [ngClass]="allDayEvent.event?.cssClass"
            [style.width.%]="(100 / days.length) * allDayEvent.span"
            [style.marginLeft.%]="(100 / days.length) * allDayEvent.offset" mwlResizable
            [resizeSnapGrid]="{ left: dayColumnWidth, right: dayColumnWidth }" [validateResize]="validateResize"
            (resizeStart)="
            allDayEventResizeStarted(eventRowContainer, allDayEvent, $event)
          " (resizing)="allDayEventResizing(allDayEvent, $event, dayColumnWidth)"
            (resizeEnd)="allDayEventResizeEnded(allDayEvent)" mwlDraggable dragActiveClass="cal-drag-active"
            [dropData]="{ event: allDayEvent.event, calendarId: calendarId }" [dragAxis]="{
            x: allDayEvent.event.draggable && allDayEventResizes.size === 0,
            y:
              !snapDraggedEvents &&
              allDayEvent.event.draggable &&
              allDayEventResizes.size === 0
          }" [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth } : {}" [validateDrag]="validateDrag"
            (dragStart)="dragStarted(eventRowContainer, event)" (dragging)="allDayEventDragMove()"
            (dragEnd)="dragEnded(allDayEvent, $event, dayColumnWidth)"
            (dblclick)="handleDoubleClickedHandled(allDayEvent.event)">
            <div class="cal-resize-handle cal-resize-handle-before-start" *ngIf="!allDayEvent.startsBeforeWeek
            " mwlResizeHandle [resizeEdges]="{ left: true }"></div>
            <vp-calendar-week-view-event [weekEvent]="allDayEvent" [tooltipPlacement]="tooltipPlacement"
              [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDelay]="tooltipDelay" [customTemplate]="eventTemplate" [eventTitleTemplate]="eventTitleTemplate"
              [eventActionsTemplate]="eventActionsTemplate" [refresh]="eventRefresh"
              (eventClicked)="handleAppointmentClicked(allDayEvent.event, $event.isSelecting)"
              (onContextMenuClicked)="onContextMenuClicked.emit($event)"
              (longPressClick)="longPressClicked.emit($event)">
            </vp-calendar-week-view-event>
            <div class="cal-resize-handle cal-resize-handle-after-end" *ngIf="!allDayEvent.endsAfterWeek
            " mwlResizeHandle [resizeEdges]="{ right: true }"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div id="weekViewCalTimeEventsD1" [class.with-all-day-event]="view.allDayEventRows.length > 0" class="cal-time-events" mwlDroppable (dragEnter)="eventDragEnter = eventDragEnter + 1"
    (dragLeave)="eventDragEnter = eventDragEnter - 1" (swipeleft)="onViewSwipe($event)"
    (swiperight)="onViewSwipe($event)">
    <div id="weekViewCalTimeLabelCol" class="cal-time-label-column" *ngIf="view.hourColumns.length > 0">
      <ng-container *ngIf="calendarRepository.daysInWeek  === 1">
        <ng-container *ngFor="let item of view.allDayEventRows">
          <div class="cal-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;">
            <div class="cal-time ng-star-inserted" [ngStyle]="{ 'border-top': 'thin solid ' + (currentTheme == 'carbon' ? '#373e45' : '#E3E7EB') }">
            </div>
          </div>
          <div class="cal-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;">
            <div class="cal-time ng-star-inserted" [ngStyle]="{ 'border-top': 'thin solid ' + (currentTheme == 'carbon' ? '#373e45' : '#E3E7EB') }">
            </div>
          </div>
          <div class="cal-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;">
            <div class="cal-time ng-star-inserted" [ngStyle]="{ 'border-top': 'thin solid ' + (currentTheme == 'carbon' ? '#373e45' : '#E3E7EB') }">
            </div>
          </div>
          <div class="cal-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;">
            <div class="cal-time ng-star-inserted" [ngStyle]="{ 'border-top': 'thin solid ' + (currentTheme == 'carbon' ? '#373e45' : '#E3E7EB') }">
            </div>
          </div>
        </ng-container>
      </ng-container>
      <div *ngFor="
          let hour of view.hourColumns[0].hours;
          trackBy: trackByHour;index as index;
          let odd = odd
        " class="cal-hour" [class.cal-hour-odd]="odd">

        <vp-calendar-week-view-hour-segment *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
          [style.height.px]="42" [segment]="segment" [segmentHeight]="42"
          [locale]="locale" [customTemplate]="hourSegmentTemplate" [isTimeLabel]="true"
          (hourSegmentContextMenuClicked)="hourSegmentContextMenuClicked.emit($event)">
        </vp-calendar-week-view-hour-segment>
        <ng-container *ngIf="calendarRepository?.daysInWeek === 1">
           <ng-container *ngFor="let i of getDataToLoadMoreRow(index)">
            <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
            <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
            <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
            <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
          </ng-container>
        </ng-container>

      </div>
    </div>

    <div id="weekViewCalHourCols" class="cal-day-columns" [class.cal-resize-active]="timeEventResizes.size > 0"
      #dayColumnsOneDay>
      <ng-container *ngIf="calendarRepository.daysInWeek  === 1">
        <div *ngFor="let eventRow of view.allDayEventRows;index as index; trackBy: trackById" #eventRowContainer
          class="cal-events-row all-day-mobile" style="position: absolute;" [style.top.px]="index  * 168" [style.height.px]="168"
          [style.left.px]="60" >
          <div *ngFor="
          let allDayEvent of eventRow.row;
          trackBy: trackByDayOrWeekEvent
        " #event style="padding-bottom: 4px;" class="cal-event-container" [class.cal-draggable]="
          allDayEvent.event.draggable && allDayEventResizes.size === 0
        " [class.cal-starts-within-week]="!allDayEvent.startsBeforeWeek"
            [class.cal-ends-within-week]="!allDayEvent.endsAfterWeek" [ngClass]="allDayEvent.event?.cssClass"
            [style.width.%]="(100 / days.length) * allDayEvent.span" [style.height.%]="100"
            [style.marginLeft.%]="(100 / days.length) * allDayEvent.offset" mwlResizable
            [resizeSnapGrid]="{ left: dayColumnWidth, right: dayColumnWidth }" [validateResize]="validateResize"
            (resizeStart)="
          allDayEventResizeStarted(eventRowContainer, allDayEvent, $event)
        " (resizing)="allDayEventResizing(allDayEvent, $event, dayColumnWidth)"
            (resizeEnd)="allDayEventResizeEnded(allDayEvent)" mwlDraggable dragActiveClass="cal-drag-active"
            [dropData]="{ event: allDayEvent.event, calendarId: calendarId }" [dragAxis]="{
          x: allDayEvent.event.draggable && allDayEventResizes.size === 0,
          y:
            !snapDraggedEvents &&
            allDayEvent.event.draggable &&
            allDayEventResizes.size === 0
        }" [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth } : {}" [validateDrag]="validateDrag"
            (dragStart)="dragStarted(eventRowContainer, event)" (dragging)="allDayEventDragMove()"
            (dragEnd)="dragEnded(allDayEvent, $event, dayColumnWidth)"
            (dblclick)="handleDoubleClickedHandled(allDayEvent.event)">
            <div class="cal-resize-handle cal-resize-handle-before-start" *ngIf="!allDayEvent.startsBeforeWeek
          " mwlResizeHandle [resizeEdges]="{ left: true }"></div>
            <vp-calendar-week-view-event [weekEvent]="allDayEvent" [tooltipPlacement]="tooltipPlacement"
              [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDelay]="tooltipDelay" [customTemplate]="eventTemplate" [eventTitleTemplate]="eventTitleTemplate"
              [eventActionsTemplate]="eventActionsTemplate" [refresh]="eventRefresh"
              (eventClicked)="handleAppointmentClicked(allDayEvent.event, $event.isSelecting)"
              (onContextMenuClicked)="onContextMenuClicked.emit($event)"
              (longPressClick)="longPressClicked.emit($event)">
            </vp-calendar-week-view-event>
            <div class="cal-resize-handle cal-resize-handle-after-end" *ngIf="!allDayEvent.endsAfterWeek
          " mwlResizeHandle [resizeEdges]="{ right: true }"></div>
          </div>
        </div>
      </ng-container>


      <div id="weekViewCalHourCol_{{colIndex}}" class="cal-day-column" [class.cal-weekend]="isWeekend(column.date)"
        *ngFor="let column of view.hourColumns; trackBy: trackByHourColumn; let colIndex = index">
        <ng-container *ngFor="
        let timeEvent of column.events;
        trackBy: trackByDayOrWeekEvent;index as index
        " >
          <div
                  *ngIf="checkIsSameStartDate(timeEvent.event.start)"
                    #event
                    class="cal-event-container"
                    [class.cal-draggable]="
                      timeEvent.event.draggable && timeEventResizes.size === 0
                    "
                    [class.cal-starts-within-day]="!timeEvent.startsBeforeDay"
                    [class.cal-ends-within-day]="!timeEvent.endsAfterDay"
                    [class.padding-left]="currentDayView === 1"
                    [ngClass]="timeEvent.event.cssClass"
                    [hidden]="timeEvent.height === 0 && timeEvent.width === 0"
                    [style.top.px]="getNTop(index)"
                    [style.height.px]="160"
                    [style.left.%]="0"
                    [style.width.%]="100"
                    mwlResizable
                    [resizeSnapGrid]="{
                      left: dayColumnWidth,
                      right: dayColumnWidth,
                      top: eventSnapSize || 42,
                      bottom: eventSnapSize || 42
                    }"
                    [validateResize]="validateResize"
                    [allowNegativeResizes]="true"
                    (resizeStart)="timeEventResizeStarted(dayColumnsOneDay, timeEvent, $event)"
                    (resizing)="timeEventResizingForDayOne(timeEvent, $event)"
                    (resizeEnd)="timeEventResizeEnded(timeEvent)"
                    mwlDraggable
                    dragActiveClass="cal-drag-active"
                    [dropData]="{ event: timeEvent.event, calendarId: calendarId }"
                    [dragAxis]="{
                      x: timeEvent.event.draggable && timeEventResizes.size === 0,
                      y: timeEvent.event.draggable && timeEventResizes.size === 0
                    }"
                    [dragSnapGrid]="
                      snapDraggedEvents
                        ? { x: dayColumnWidth, y: eventSnapSize || 42 }
                        : {}
                    "
                    [ghostDragEnabled]="!snapDraggedEvents"
                    [validateDrag]="validateDrag"
                    (dragStart)="dragStarted(dayColumnsOneDay, event, timeEvent)"
                    (dragging)="dragMove(timeEvent, $event)"
                    (dragEnd)="dragEnded(timeEvent, $event, dayColumnWidth, true)"
                  >
                    <vp-calendar-week-view-event [weekEvent]="timeEvent" [tooltipPlacement]="tooltipPlacement"
                      [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
                      [tooltipDisabled]="dragActive || timeEventResizes.size > 0" [tooltipDelay]="tooltipDelay"
                      [customTemplate]="eventTemplate" [eventTitleTemplate]="eventTitleTemplate"
                      [eventActionsTemplate]="eventActionsTemplate" [refresh]="eventRefresh"
                      (eventClicked)="handleAppointmentClicked(timeEvent.event, $event.isSelecting)"
                      (onContextMenuClicked)="onContextMenuClicked.emit($event)"
                      (onDoubleClicked)="handleDoubleClickedHandled(timeEvent.event)" (longPressClick)="longPressClicked.emit($event)">
                    </vp-calendar-week-view-event>
         </div>
        </ng-container>

        <ng-container *ngIf="calendarRepository.daysInWeek  === 1">
          <ng-container *ngFor="let item of view.allDayEventRows">
            <div id="weekViewCalHourCol_{{colIndex}}_000" class="cal-hour test1">
              <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
            </div>
          </ng-container>
        </ng-container>

        <div id="weekViewCalHourCol_{{colIndex}}_{{hourIndex}}"
          *ngFor="let hour of column.hours; trackBy: trackByHour; let odd = odd; let hourIndex = index"
          class="cal-hour test1" [class.cal-hour-odd]="odd">

          <vp-calendar-week-view-hour-segment *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
            [style.height.px]="42" [segment]="segment" [segmentHeight]="42"
            [locale]="locale" [customTemplate]="hourSegmentTemplate"
            (vpCalClick)="hourSegmentClicked.emit({ date: segment.date })"
            [clickListenerDisabled]="hourSegmentClicked.observers.length === 0" mwlDroppable [dragOverClass]="
              !dragActive || !snapDraggedEvents ? 'cal-drag-over' : null
            " dragActiveClass="cal-drag-active" (drop)="eventDropped($event, segment.date, false)"
            (hourSegmentContextMenuClicked)="hourSegmentContextMenuClicked.emit($event)">
          </vp-calendar-week-view-hour-segment>
        </div>

          <ng-container *ngFor="let item of extraCellAddInBottom">
            <div id="weekViewCalHourCol_{{colIndex}}_000" class="cal-hour extracell-at-bottom">
              <div class="cal-after-hour-start custom-one cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start custom-one cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start custom-one cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
              <div class="cal-after-hour-start custom-one cal-hour-segment ng-star-inserted" style="height: 42px;"></div>
            </div>
          </ng-container>
      </div>
    </div>
    <div #weekCalTimeline1Day class="cal-timeline-container time-line-bar-one-day-view" [class.hide-time-line]="calendarRepository.daysInWeek  != 1">
      <div class="timeline-bar-day-one">
        <div class="time-line-dot"></div>
      </div>
    </div>
  </div>
</div>

<!-- One day End -->
<!-- <ng-template #elseTemplate> -->
  <div class="cal-week-view" [ngClass]="{'hidden-view': calendarRepository.daysInWeek == 1}" >
    <div
      class="cal-week-view-header"
      (swipeleft)="onViewSwipe($event)"
      (swiperight)="onViewSwipe($event)"
    >
      <vp-calendar-week-view-header
        [days]="days"
        [locale]="locale"
        [customTemplate]="headerTemplate"
        (dayHeaderClicked)="dayHeaderClicked.emit($event)"
        (eventDropped)="eventDropped({ dropData: $event }, $event.newStart, true)"
      >
      </vp-calendar-week-view-header>
      <div
        class="cal-all-day-events"
        #allDayEventsContainer
        *ngIf="view.allDayEventRows.length > 0"
        mwlDroppable
        (dragEnter)="eventDragEnter = eventDragEnter + 1"
        (dragLeave)="eventDragEnter = eventDragEnter - 1"
      >
        <div class="cal-day-columns">
            <div class="cal-time-label-column">
                <span class="all-day-title">{{ 'CALENDARS.ALL_DAY_LBL' | translate }}</span>
              </div>
          <div
            class="cal-day-column"
            [class.cal-weekend]="day.isWeekend"
            *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
            [ngStyle]="{ 'width': isMobileScreen ? 'calc((100% - 52px) / 8)' : 'calc((100% - 52px) / 7)'}"
            mwlDroppable
            dragOverClass="cal-drag-over"
            (drop)="eventDropped($event, day.date, true)"
            (contextmenu)="hourSegmentContextMenuClicked.emit({ $event: $event, segment: day.date, allDay: true })"
          ></div>
        </div>
        <div class="week-scroll-all-day">
        <div
          *ngFor="let eventRow of view.allDayEventRows; trackBy: trackById"
          #eventRowContainer
          class="cal-events-row"
        >
          <div
            *ngFor="
              let allDayEvent of eventRow.row;
              trackBy: trackByDayOrWeekEvent
            "
            #event
            class="cal-event-container"
            [class.cal-draggable]="
              allDayEvent.event.draggable && allDayEventResizes.size === 0
            "
            [class.cal-starts-within-week]="!allDayEvent.startsBeforeWeek"
            [class.cal-ends-within-week]="!allDayEvent.endsAfterWeek"
            [ngClass]="allDayEvent.event?.cssClass"
            [style.width.%]="(100 / days.length) * allDayEvent.span"
            [style.marginLeft.%]="(100 / days.length) * allDayEvent.offset"
            mwlResizable
            [resizeSnapGrid]="{ left: dayColumnWidth, right: dayColumnWidth }"
            [validateResize]="validateResize"
            (resizeStart)="
              allDayEventResizeStarted(eventRowContainer, allDayEvent, $event)
            "
            (resizing)="allDayEventResizing(allDayEvent, $event, dayColumnWidth)"
            (resizeEnd)="allDayEventResizeEnded(allDayEvent)"
            mwlDraggable
            dragActiveClass="cal-drag-active"
            [dropData]="{ event: allDayEvent.event, calendarId: calendarId }"
            [dragAxis]="{
              x: allDayEvent.event.draggable && allDayEventResizes.size === 0,
              y:
                !snapDraggedEvents &&
                allDayEvent.event.draggable &&
                allDayEventResizes.size === 0
            }"
            [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth } : {}"
            [validateDrag]="validateDrag"
            (dragStart)="dragStarted(eventRowContainer, event)"
            (dragging)="allDayEventDragMove()"
            (dragEnd)="dragEnded(allDayEvent, $event, dayColumnWidth)"
            (dblclick)="handleDoubleClickedHandled(allDayEvent.event)"
          >
            <div
              class="cal-resize-handle cal-resize-handle-before-start"
              *ngIf="!allDayEvent.startsBeforeWeek
              "
              mwlResizeHandle
              [resizeEdges]="{ left: true }"
            ></div>
            <vp-calendar-week-view-event
              [weekEvent]="allDayEvent"
              [tooltipPlacement]="tooltipPlacement"
              [tooltipTemplate]="tooltipTemplate"
              [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDelay]="tooltipDelay"
              [customTemplate]="eventTemplate"
              [eventTitleTemplate]="eventTitleTemplate"
              [eventActionsTemplate]="eventActionsTemplate"
              [refresh]="eventRefresh"
              (eventClicked)="handleAppointmentClicked(allDayEvent.event, $event.isSelecting)"
              (onContextMenuClicked)="onContextMenuClicked.emit($event)"
              (longPressClick)="longPressClicked.emit($event)"
            >
            </vp-calendar-week-view-event>
            <div
              class="cal-resize-handle cal-resize-handle-after-end"
              *ngIf="!allDayEvent.endsAfterWeek
              "
              mwlResizeHandle
              [resizeEdges]="{ right: true }"
            ></div>
          </div>
        </div>
      </div>

      </div>
    </div>
    <div
      id="weekViewCalTimeEvents"
      class="cal-time-events"
      [class.with-all-day-event]="view.allDayEventRows.length > 0"
      mwlDroppable
      (dragEnter)="eventDragEnter = eventDragEnter + 1"
      (dragLeave)="eventDragEnter = eventDragEnter - 1"
      (swipeleft)="onViewSwipe($event)"
      (swiperight)="onViewSwipe($event)"
      [style.height]="weekViewCalTimeEventsHeight"
    >
      <div id="weekViewCalTimeLabelCol" class="cal-time-label-column" *ngIf="view.hourColumns.length > 0">
        <div
          *ngFor="
            let hour of view.hourColumns[0].hours;
            trackBy: trackByHour;
            let odd = odd
          "
          class="cal-hour"
          [class.cal-hour-odd]="odd"
        >
          <vp-calendar-week-view-hour-segment
            *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
            [style.height.px]="hourSegmentHeight"
            [segment]="segment"
            [segmentHeight]="hourSegmentHeight"
            [locale]="locale"
            [customTemplate]="hourSegmentTemplate"
            [isTimeLabel]="true"
            (hourSegmentContextMenuClicked)="hourSegmentContextMenuClicked.emit($event)"
          >
          </vp-calendar-week-view-hour-segment>
        </div>
      </div>
      <div
        id="weekViewCalHourCols"
        class="cal-day-columns"
        [class.cal-resize-active]="timeEventResizes.size > 0"
        #dayColumns
      >
        <div
          id="weekViewCalHourCol_{{colIndex}}"
          class="cal-day-column"
          [class.cal-weekend]="isWeekend(column.date)"
          *ngFor="let column of view.hourColumns; trackBy: trackByHourColumn; let colIndex = index"
        >
          <div
            *ngFor="
              let timeEvent of column.events;
              trackBy: trackByDayOrWeekEvent
            "
            #event
            class="cal-event-container"
            [class.cal-draggable]="
              timeEvent.event.draggable && timeEventResizes.size === 0
            "
            [class.cal-starts-within-day]="!timeEvent.startsBeforeDay"
            [class.cal-ends-within-day]="!timeEvent.endsAfterDay"
            [ngClass]="timeEvent.event.cssClass"
            [hidden]="timeEvent.height === 0 && timeEvent.width === 0"
            [style.top.px]="timeEvent.top"
            [style.height.px]="timeEvent.height"
            [style.left.%]="timeEvent.left"
            [style.width.%]="timeEvent.width"
            mwlResizable
            [resizeSnapGrid]="{
              left: dayColumnWidth,
              right: dayColumnWidth,
              top: eventSnapSize || hourSegmentHeight,
              bottom: eventSnapSize || hourSegmentHeight
            }"
            [validateResize]="validateResize"
            [allowNegativeResizes]="true"
            (resizeStart)="timeEventResizeStarted(dayColumns, timeEvent, $event)"
            (resizing)="timeEventResizing(timeEvent, $event)"
            (resizeEnd)="timeEventResizeEnded(timeEvent)"
            mwlDraggable
            dragActiveClass="cal-drag-active"
            [dropData]="{ event: timeEvent.event, calendarId: calendarId }"
            [dragAxis]="{
              x: timeEvent.event.draggable && timeEventResizes.size === 0,
              y: timeEvent.event.draggable && timeEventResizes.size === 0
            }"
            [dragSnapGrid]="
              snapDraggedEvents
                ? { x: dayColumnWidth, y: eventSnapSize || hourSegmentHeight }
                : {}
            "
            [ghostDragEnabled]="!snapDraggedEvents"
            [validateDrag]="validateDrag"
            (dragStart)="dragStarted(dayColumns, event, timeEvent)"
            (dragging)="dragMove(timeEvent, $event)"
            (dragEnd)="dragEnded(timeEvent, $event, dayColumnWidth, true)"
          >
            <div
              id="canEventResizeHandlerTop"
              class="cal-resize-handle cal-resize-handle-before-start"
              *ngIf="
                !timeEvent.startsBeforeDay
              "
              mwlResizeHandle
              [resizeEdges]="{
                left: true,
                top: true
              }"
            ></div>
            <vp-calendar-week-view-event
              [weekEvent]="timeEvent"
              [tooltipPlacement]="tooltipPlacement"
              [tooltipTemplate]="tooltipTemplate"
              [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDisabled]="dragActive || timeEventResizes.size > 0"
              [tooltipDelay]="tooltipDelay"
              [customTemplate]="eventTemplate"
              [eventTitleTemplate]="eventTitleTemplate"
              [eventActionsTemplate]="eventActionsTemplate"
              [refresh]="eventRefresh"
              (eventClicked)="handleAppointmentClicked(timeEvent.event, $event.isSelecting)"
              (onContextMenuClicked)="onContextMenuClicked.emit($event)"
              (onDoubleClicked)="handleDoubleClickedHandled(timeEvent.event)"
              (longPressClick)="longPressClicked.emit($event)"
            >
            </vp-calendar-week-view-event>
            <div
              id="canEventResizeHandlerBottom"
              class="cal-resize-handle cal-resize-handle-after-end"
              *ngIf="!timeEvent.endsAfterDay
              "
              mwlResizeHandle
              [resizeEdges]="{
                right: true,
                bottom: true
              }"
            ></div>
          </div>

          <div
            id="weekViewCalHourCol_{{colIndex}}_{{hourIndex}}"
            *ngFor="let hour of column.hours; trackBy: trackByHour; let odd = odd; let hourIndex = index"
            class="cal-hour"
            [class.cal-hour-odd]="odd"
          >
            <vp-calendar-week-view-hour-segment
              *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
              [style.height.px]="hourSegmentHeight"
              [segment]="segment"
              [segmentHeight]="hourSegmentHeight"
              [locale]="locale"
              [customTemplate]="hourSegmentTemplate"
              (vpCalClick)="hourSegmentClicked.emit({ date: segment.date })"
              [clickListenerDisabled]="hourSegmentClicked.observers.length === 0"
              mwlDroppable
              [dragOverClass]="
                !dragActive || !snapDraggedEvents ? 'cal-drag-over' : null
              "
              dragActiveClass="cal-drag-active"
              (drop)="eventDropped($event, segment.date, false)"
              (hourSegmentContextMenuClicked)="hourSegmentContextMenuClicked.emit($event)"
            >
            </vp-calendar-week-view-hour-segment>
          </div>
        </div>
      </div>
      <div #weekCalTimeline  class="cal-timeline-container" [class.hide-time-line]="calendarRepository.daysInWeek  === 1">
        <div class="timeline-bar">
          <mat-icon  class="mdi-24px" fontSet="mdi" fontIcon="mdi-ray-start-arrow"></mat-icon>
        </div>
      </div>
    </div>
  </div>
<!-- </ng-template> -->
 </div>



<div class="custom-code-3-day" *ngIf="calendarRepository.daysInWeek == 3 && isMobileScreen"
[style.display]="(calendarRepository.daysInWeek == 3 && isMobileScreen) ? 'block': 'none'"
>
  <div class="calendar-grid-custom d-flex " #customThreeDayView
  id="weekViewCalTimeEvents3Day"
  (swipeleft)="onViewSwipe($event)" (swiperight)="onViewSwipe($event)"
    >


    <div class="time-marker" #custom3DayTimeMarker id="custom3daytime" [style.top.px]="getTimeMarkerPostition"></div>
    <div>
      <div class="calendar-cell header time-header sticky-time-header">{{ 'CALENDARS.TIME_LBL' | translate }}</div>
      <div class="all-day-ev-app-section no-outline" [style.height.px]="view.allDayEventRows.length * 40">

       </div>
      <ng-container *ngFor="let time of timeSlotForShowingTime">
        <div class="calendar-cell time-label">
          {{time}}
        </div>
      </ng-container>
    </div>
    <div *ngFor="let day of daysCustom; index as dayIndex">
      <div class="calendar-cell header time-header sticky-time-header">
        <span class="date" [class.current]="(day | date: 'yyyy-MM-dd') === (today | date: 'yyyy-MM-dd')"> {{ day | date: 'd' }}</span>
        <span class="day" > {{ day | date: 'EEE' :'':locale}}</span>
      </div>
      <div class="all-day-ev-app-section" [style.height.px]="view.allDayEventRows.length * 40"
      [ngStyle]="{
        'z-index': 220 - (dayIndex * 2),
        visibility : day3VisiblityAftersetPosition ? 'visible' : 'hidden'
       }"
        >

        <ng-container *ngIf="dayIndex == 0">
          <div class="time-all-left-section" *ngIf="allDayForCustomEvent3day.day1 && allDayForCustomEvent3day.day1.length">
          </div>
          <ng-container *ngFor="let allDayEv of allDayForCustomEvent3day.day1; index as i">
              <div class="all-d-ev" [ngClass]="[
                allDayEv.fba ? 'all-d-ev state-indicator-' + allDayEv.fba : 'all-d-ev',
                allDayEv.class === 'PRI' ? 'with-private' : ''
              ]"
                style=" position: absolute;" [class.selection]="allDayEv?.selected" (click)="selectAllEvent(allDayEv)"
                [style.top.px]="allDayEv.count ? (allDayEv.count * 40) + 3 : (i * 40) + 3"
                [style.width.px]="allDayEv.span ? (allDayEv.span * customCellWidth) - 16: 15" *ngIf="allDayEv.offset == 0" [ngStyle]="{
                                    marginTop: i > 0 ? '0': '0',
                                    background: getBackgroundColor(allDayEv.bgcolor)

                                  }">
                <div *ngIf="allDayEv.class === 'PRI'" class="private-all-day">
                  <ng-container *ngTemplateOutlet="privateIcon"></ng-container>
                </div>
                {{allDayEv.title}}
              </div>
          </ng-container>
        </ng-container>

         <ng-container *ngIf="dayIndex == 1">
          <ng-container *ngFor="let allDayEv of allDayForCustomEvent3day.day2; index as i">
              <div class="all-d-ev" [ngClass]="[
                allDayEv.fba ? 'all-d-ev state-indicator-' + allDayEv.fba : 'all-d-ev',
                allDayEv.class === 'PRI' ? 'with-private' : ''
              ]"
                [style.top.px]="22 * i" style="position: absolute;" [class.selection]="allDayEv?.selected"
                (click)="selectAllEvent(allDayEv)" [style.top.px]="allDayEv.count ? (allDayEv.count * 40) + 3 : (i * 40) + 3"
                [style.width.px]="allDayEv.span ? (allDayEv.span * customCellWidth) - 16: 15" [ngStyle]="{
                                                  marginTop: i > 0 ? '0': '0',
                                                 background: getBackgroundColor(allDayEv.bgcolor)}">
                <div *ngIf="allDayEv.class === 'PRI'" class="private-all-day">
                  <ng-container *ngTemplateOutlet="privateIcon"></ng-container>
                </div>
                {{allDayEv.title}}
              </div>
          </ng-container>
        </ng-container>

         <ng-container *ngIf="dayIndex == 2">
          <ng-container *ngFor="let allDayEv of allDayForCustomEvent3day.day3; index as i">
              <div class="all-d-ev"  [ngClass]="[
                allDayEv.fba ? 'all-d-ev state-indicator-' + allDayEv.fba : 'all-d-ev',
                allDayEv.class === 'PRI' ? 'with-private' : ''
              ]" [style.top.px]="22 * i" style="position: absolute;" [class.selection]="allDayEv?.selected" (click)="selectAllEvent(allDayEv)"
               [style.top.px]="allDayEv.count ? (allDayEv.count * 40) + 3 : (i * 40) + 3"
               [style.width.px]="allDayEv.span ? (allDayEv.span * customCellWidth) - 16: 15"
               [ngStyle]="{
                      marginTop: i > 0 ? '0': '0',
                      background: getBackgroundColor(allDayEv.bgcolor)  }" >
                       <div *ngIf="allDayEv.class === 'PRI'" class="private-all-day">
                          <ng-container *ngTemplateOutlet="privateIcon"></ng-container>
                      </div>
              {{allDayEv.title}}
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container *ngFor="let time of timeSlots" style="position: relative;">
        <div class="cal-new-cell placeholder" (click)="clickTimeSlot(time, day)" >
          <ng-container *ngIf="checkAppointmentForThisTimeSlot(day, time, dayIndex) as appointmentsInSlot">
            <ng-container *ngIf="appointmentsInSlot.length === 0; else showAppointments">
              <span class="placeholder"></span>
            </ng-container>
            <ng-template #showAppointments>
              <ng-container *ngFor="let appt of appointmentsInSlot; index as i">
                    <div *ngIf="appt && appt?.groupIndex == 5 && appt?.moreAppointment"
                      [ngStyle]="{
                                    height: appt.height + 'px',
                                    top: view.allDayEventRows.length > 0 ? (view.allDayEventRows.length * 40 ) + (appt.top - 1) + 'px':  (appt.top - 1) + 'px' ,
                                    width: (appt.width - 3) + 'px',
                                    left: appt.left + 'px',
                                     'z-index': (appt?.group_front ? appt.index + appt.last_index + 1 :( appt?.selected ? 999 :( appt.index ?? 1))),
                                    position: 'absolute'

                                  }" style="
                                    border-radius: 50%;display: flex; align-items: center; justify-content: end;
                                    color: black; background-color: transparent;"
                           >
                        <div style="background-color: #337CBD; height: 25px; width: 25px;color: white;
                        display: flex; align-items: center; justify-content: center;margin-right: 4px; border-radius: 50%;"
                        (click)="openListForMoreAppt(dayIndex, appt)"
                        >{{appt?.moreAppointment}}+</div>
                      </div>


                    <div class="appointment absol"
                      [className]="appt.fba ? 'appointment absol state-indicator-' + appt.fba : 'appointment absol'"
                      [class.selection]="appt?.selected" (click)=" openReplaceToFront(appt, dayIndex)"
                       *ngIf="appt" [ngStyle]="{
                                          height: (appt.height - 2) + 'px',
                                          top: view.allDayEventRows.length > 0 ? (view.allDayEventRows.length * 40 ) + (appt.top - 1) + 'px':  (appt.top - 1) + 'px' ,
                                          width: (appt.width - 3) + 'px',
                                          left: appt.left + 'px',
                                           'z-index': (appt?.group_front ? appt.index + appt.last_index + 1 :( appt?.selected ? 999 :( appt.index ?? 1))),
                                        visibility : (appt && appt?.groupIndex > 4 && appt?.moreAppointment) ? 'hidden' : (day3VisiblityAftersetPosition ? 'visible' : 'hidden')
                                        }"
                                        style="
                                          border-radius: 4px;
                                          color: white;">


                      <div class="flex-app" [ngStyle]="{
                                          background: appt.id != 1000111 ? appt.color : '#ffffff'
                                        }">
                        <div class="top-handle" #draggable (pointerdown)="onPointerDown($event, appt, false)" (pointermove)="onPointerMove($event, false, appt)"
                          (pointerup)="onPointerUp($event, appt, false)" (pointercancel)="onPointerCancel($event, appt, false)" (contextmenu)="onContextMenu($event)"
                          [ngStyle]="{ 'height': (appt && appt.pointerUP) ? '100px': '14px', 'top': (appt && appt.pointerUP) ? '-50px': '0' }"
                           style=" width: 100%;
                           top: 0;
                            position: absolute;
                            background: transparent;" *ngIf="appt.id != 1000111">
                        </div>
                        <div class="state-indicator" [className]="appt.fba ? 'state-indicator state-indicator-' + appt.fba : ''"
                          *ngIf="appt.id != 1000111">
                        </div>
                        <div class="app-data" *ngIf="appt.width > 25 && appt.id != 1000111"
                          [ngClass]="{'app-declined': appt?.ptst === 'DE','app-tentatively-accepted': appt?.ptst === 'TE', 'basic-height': appt.height > 43, 'small-appointment':  appt.height < 44}"
                          [ngStyle]="{}">
                          <div class="title" [ngClass]="{ 'basic-height': appt.height > 43, 'small-appointment':  appt.height < 44}">
                            <span class="tag-n-recur">
                              <mat-icon *ngIf="appt.tn && appt.tn !== '' && appt.tn.split(',').length === 1"
                                [style.color]="getTagColorByNames(appt?.tn)"
                                style="vertical-align: middle; font-size: 14px; height: 16px; width: 16px;"
                                class="event-tag-item">local_offer</mat-icon>

                              <svg *ngIf="appt.recur" class="recur" width="12px" height="12px" viewBox="0 0 24 24" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Icon/product/sync" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g id="Icon-24px" transform="translate(4.000000, 1.000000)" fill="#000000">
                                    <path
                                      d="M8,3 L8,0 L4,4 L8,8 L8,5 C11.31,5 14,7.69 14,11 C14,12.01 13.75,12.97 13.3,13.8 L14.76,15.26 C15.54,14.03 16,12.57 16,11 C16,6.58 12.42,3 8,3 L8,3 Z M8,17 C4.69,17 2,14.31 2,11 C2,9.99 2.25,9.03 2.7,8.2 L1.24,6.74 C0.46,7.97 0,9.43 0,11 C0,15.42 3.58,19 8,19 L8,22 L12,18 L8,14 L8,17 L8,17 Z"
                                      id="Shape"></path>
                                  </g>
                                </g>
                              </svg>

                              <svg *ngIf="appt.class === 'PRI'" class="recur private-lock-icon" width="12px" height="12px"
                                viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Icon/product/lock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g id="Icon-24px" transform="translate(4.000000, 1.000000)" fill="#317bbc">
                                    <path
                                      d="M14,7 L13,7 L13,5 C13,2.24 10.76,0 8,0 C5.24,0 3,2.24 3,5 L3,7 L2,7 C0.9,7 0,7.9 0,9 L0,19 C0,20.1 0.9,21 2,21 L14,21 C15.1,21 16,20.1 16,19 L16,9 C16,7.9 15.1,7 14,7 L14,7 Z M8,16 C6.9,16 6,15.1 6,14 C6,12.9 6.9,12 8,12 C9.1,12 10,12.9 10,14 C10,15.1 9.1,16 8,16 L8,16 Z M11.1,7 L4.9,7 L4.9,5 C4.9,3.29 6.29,1.9 8,1.9 C9.71,1.9 11.1,3.29 11.1,5 L11.1,7 L11.1,7 Z"
                                      id="Shape"></path>
                                  </g>
                                </g>
                              </svg>

                            </span>
                            {{ appt.title }}
                          </div>
                          <ng-container *ngIf="appt.height > 44">
                            <div class="time-section">
                              <ng-container *ngIf="locale === 'en'">
                                {{appt.start | date : 'hh:mm:aa'}} - {{appt.end | date : 'hh:mm:aa'}}
                              </ng-container>
                              <ng-container *ngIf="locale === 'de'">
                                {{appt.start | date:'HH:mm': '': locale}} - {{appt.end | date:'HH:mm': '': locale}}
                              </ng-container>
                            </div>

                              <span *ngIf="view !== 'month' && appt.location !== ''"
                                  class="cal-event-location"

                                >
                                <a
                                *ngIf="!!appt && !!appt.location && appt?.location?.indexOf('/assets/meeting') !== -1 && !pastCheck(appt)"
                                [href]="appt.location"
                                target="_blank"
                                class="join-meeting open-new-window">{{ 'JOIN' | translate }}</a>
                            </span>
                          </ng-container>

                        </div>
                        <div class="bottom-handle" #draggable (pointerdown)="onPointerDown($event, appt, true)"
                          (pointermove)="onPointerMove($event, true, appt)" (pointerup)="onPointerUp($event, appt, true)"
                          (pointercancel)="onPointerCancel($event, appt, true)" (contextmenu)="onContextMenu($event)"
                           [ngStyle]="{ 'height': (appt && appt.pointerBottom) ? '100px': '14px', 'bottom': (appt && appt.pointerBottom) ? '-50px': '0' }"
                          *ngIf="appt.height > 44 && appt.id != 1000111"  style="width: 100%;
                                          bottom: 0;
                                          position: absolute;
                                          background: transparent;"></div>

                      </div>
                    </div>
              </ng-container>

            </ng-template>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #privateIcon>
     <svg  class="recur private-lock-icon" width="12px" height="12px"
          viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Icon/product/lock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icon-24px" transform="translate(4.000000, 1.000000)" fill="#317bbc">
              <path
                d="M14,7 L13,7 L13,5 C13,2.24 10.76,0 8,0 C5.24,0 3,2.24 3,5 L3,7 L2,7 C0.9,7 0,7.9 0,9 L0,19 C0,20.1 0.9,21 2,21 L14,21 C15.1,21 16,20.1 16,19 L16,9 C16,7.9 15.1,7 14,7 L14,7 Z M8,16 C6.9,16 6,15.1 6,14 C6,12.9 6.9,12 8,12 C9.1,12 10,12.9 10,14 C10,15.1 9.1,16 8,16 L8,16 Z M11.1,7 L4.9,7 L4.9,5 C4.9,3.29 6.29,1.9 8,1.9 C9.71,1.9 11.1,3.29 11.1,5 L11.1,7 L11.1,7 Z"
                id="Shape"></path>
            </g>
          </g>
        </svg>
</ng-template>